import { getUpdatedSavingValues } from '../../../sites/petervardy/js/site_scripts/mtc_get_savings_breakdown';

$(document).ready(function () {
    "use strict";

    if ($('.rangeSlider').length > 0) {
        rangeSlider();
    }

    if($('#financeCalculator').get(0)) {
        updateFinanceCalculator($('form.financeFormItem'), 'first run');
    }

    if($('#financeCalculatorSmall').get(0)) {
        updateFinanceCalculatorSmall($('form.financeFormItemSmall'), 'first run');
    }

    function updateFinanceCalculator(this_form, first_run) {

        var csrf = '';
        var csrf_element = document.querySelector('meta[name="csrf"]');

        if (csrf_element) {
            csrf = csrf_element.getAttribute('content');
        }

        $.ajax({
            url: '/modules/FinanceCalculator/ajax.php',
            type: "post",
            data: this_form.serialize(),
            csrf: csrf,
            beforeSend: function(){
                $('#loadingOverlay').fadeIn(500);
            },
            success: function (response) {

                // get finance calculator form data
                var finance_form_data = this_form.serializeArray();
                var finance_array = [];

                for(var i = 0; i < finance_form_data.length; i++) {
                    finance_array[finance_form_data[i]['name']] = finance_form_data[i]['value'];
                }

                var finance_data = '';

                if(Object.keys(finance_array).length > 0) {
                    finance_data += '&how_many_months=' + encodeURIComponent(finance_array['finance_calculator_term']);
                    finance_data += '&deposit=' + encodeURIComponent(finance_array['finance_calculator_deposit']);
                }

                var vehicle_id = $('#financeCalculator [name=item_id]').val();
                var vehicle_data = '';

                /*
                // this provides vehicle data for the car money link.
                // the car money link is not currently used, so no need to make this call.
                // get vehicle data
                $.ajax({
                    url: '/sites/petervardy/templates/ajax/item.get.php',
                    type: "post",
                    async: false,
                    data: {
                        id: vehicle_id
                    },
                    success: function (item_response) {
                        var item = $.parseJSON(item_response);
                        vehicle_data += '&make=' + encodeURIComponent(item.make);
                        vehicle_data += '&model=' + encodeURIComponent(item.model);
                        vehicle_data += '&car_price=' + encodeURIComponent(item.price);
                        vehicle_data += '&borrow_amount=' + encodeURIComponent(item.price);
                        vehicle_data += '&mileage=' + encodeURIComponent(item.mileage);
                        vehicle_data += '&url=' + encodeURIComponent(item.url);
                        vehicle_data += '&vrm=' + encodeURIComponent(item.registration_number);
                    }
                });
                */

                var current_tab = $('.financeContentMobileTab.active').index();

                $('#financeCalculator').replaceWith(response);

                $('.financeContentMobileTab.active').removeClass('active');
                $('.financeContentMobileTab').eq(current_tab).find('.js_financeProduct').trigger('click');

                var href = 'https://www.carmoney.co.uk/car-finance-calculator/?referring_source=petervardy_FPAV';

                // carmoney link is not currently used
                //$('.link_carmoney').attr('href', href + finance_data + vehicle_data);

                var offset,
                    off_top,
                    link_to,
                    sticky_header_height = 0;

                link_to = $('.financeCalculator #finance_calculator_submit').attr('href');

                if ($('body').find($(link_to)).length > 0 && first_run != 'first run') {

                    if ($('#content').find($('.stickyHeader')).length > 0) {
                        sticky_header_height = $('#content .stickyHeader').outerHeight();
                    }

                    offset = $(link_to).offset();
                    off_top = offset.top;

                    $('body,html').stop(true, false).animate({

                        scrollTop: (off_top - sticky_header_height) - 50
                    }, 800);
                }

                financeVideoOverlay();

                $('#financeCalculator [name=deposit]').val(encodeURIComponent(finance_array['finance_calculator_deposit']));
                $('#financeCalculator [name=term]').val(encodeURIComponent(finance_array['finance_calculator_term']));
                $('#financeCalculator [name=annual_mileage]').val(encodeURIComponent(finance_array['finance_calculator_mileage']));

                // update storefront hidden fields
                if('finance_calculator_credit_rating' in finance_array) {
                    $('#financeCalculator [name=credit_tier]').val(encodeURIComponent(finance_array['finance_calculator_credit_rating']));
                }

                // update item hidden fields.
                // commenting out for now because the corresponding monthly payment is not updated.
                // changing the hidden fields would mean the hidden fields don't correspond with the displayed price.
                //$('.item [name=credit_tier]').val(encodeURIComponent(finance_array['finance_calculator_credit_rating']));
                //$('.item [name=deposit]').val(encodeURIComponent(finance_array['finance_calculator_deposit']));
                //$('.item [name=term]').val(encodeURIComponent(finance_array['finance_calculator_term']));
                //$('.item [name=annual_mileage]').val(encodeURIComponent(finance_array['finance_calculator_mileage']));

                // update the Build Your Deal CTA.
                // commenting out for now because the corresponding monthly payment is not updated.
                // changing the hidden fields would mean the hidden fields don't correspond with the displayed price.
                //$('.buildYourDealCta [name=credit_tier]').val(encodeURIComponent(finance_array['finance_calculator_credit_rating']));
                //$('.buildYourDealCta [name=deposit]').val(encodeURIComponent(finance_array['finance_calculator_deposit']));
                //$('.buildYourDealCta [name=term]').val(encodeURIComponent(finance_array['finance_calculator_term']));
                //$('.buildYourDealCta [name=annual_mileage]').val(encodeURIComponent(finance_array['finance_calculator_mileage']));

                // FPA variant
                // commenting out for now because the corresponding monthly payment is not updated.
                // changing the hidden fields would mean the hidden fields don't correspond with the displayed price.
                //$('.getStartedMobileWrap [name=credit_tier]').val(encodeURIComponent(finance_array['finance_calculator_credit_rating']));

                $('#loadingOverlay').fadeOut(500);
            }
        });
    }

    function updateFinanceCalculatorSmall(this_form, first_run) {

        $.ajax({
            url: '/modules/FinanceCalculator/ajax_small.php',
            type: "post",
            data: this_form.serialize(),
            beforeSend: function(){
                // $('#loadingOverlay').fadeIn(500);
            },
            success: function (response) {
                // get finance calculator form data
                var finance_form_data = this_form.serializeArray(),
                    finance_array = [],
                    finance_data = '',
                    vehicle_id = $('#financeCalculatorSmall [name=item_id]').val(),
                    vehicle_data = '';

                for (var i = 0; i < finance_form_data.length; i++) {
                    finance_array[finance_form_data[i]['name']] = finance_form_data[i]['value'];
                }

                if (Object.keys(finance_array).length > 0) {
                    finance_data += '&how_many_months=' + encodeURIComponent(finance_array['finance_calculator_term']);
                    finance_data += '&deposit=' + encodeURIComponent(finance_array['finance_calculator_deposit']);
                }

                /*
                 // this provides vehicle data for the car money link.
                 // the car money link is not currently used, so no need to make this call.
                 // get vehicle data
                // get vehicle data
                $.ajax({
                    url: '/sites/petervardy/templates/ajax/item.get.php',
                    type: "post",
                    async: false,
                    data: {
                        id: vehicle_id
                    },
                    success: function (item_response) {
                        var item = $.parseJSON(item_response);
                        vehicle_data += '&make=' + encodeURIComponent(item.make);
                        vehicle_data += '&model=' + encodeURIComponent(item.model);
                        vehicle_data += '&car_price=' + encodeURIComponent(item.price);
                        vehicle_data += '&borrow_amount=' + encodeURIComponent(item.price);
                        vehicle_data += '&mileage=' + encodeURIComponent(item.mileage);
                        vehicle_data += '&url=' + encodeURIComponent(item.url);
                        vehicle_data += '&vrm=' + encodeURIComponent(item.registration_number);
                    }
                });
                */

                var current_tab = $('#financeCalculatorSmall .financeContentMobileTab.active').index();

                $('#financeCalculatorSmall').replaceWith(response);

                $('#financeCalculatorSmall .financeContentMobileTab.active').removeClass('active');
                $('#financeCalculatorSmall .financeContentMobileTab').eq(current_tab).find('.js_financeProduct').trigger('click');

                var href = 'https://www.carmoney.co.uk/car-finance-calculator/?referring_source=petervardy_FPAV';

                // carmoney link is not currently used
                //$('.link_carmoney').attr('href', href + finance_data + vehicle_data);

                var offset,
                    off_top,
                    link_to,
                    sticky_header_height = 0;

                link_to = $('#financeCalculatorSmall .financeCalculator #finance_calculator_submit').attr('href');

                if ($('body').find($(link_to)).length > 0 && first_run != 'first run') {

                    if ($('#content').find($('.stickyHeader')).length > 0) {
                        sticky_header_height = $('#content .stickyHeader').outerHeight();
                    }

                    offset = $(link_to).offset();
                    off_top = offset.top;

                    $('body,html').stop(true, false).animate({

                        scrollTop: (off_top - sticky_header_height) - 50
                    }, 800);
                }

                financeVideoOverlay();

                $('#financeCalculatorSmall [name=deposit]').val(encodeURIComponent(finance_array['finance_calculator_deposit']));
                $('#financeCalculatorSmall [name=term]').val(encodeURIComponent(finance_array['finance_calculator_term']));
                $('#financeCalculatorSmall [name=annual_mileage]').val(encodeURIComponent(finance_array['finance_calculator_mileage']));

                // update storefront hidden fields
                if('finance_calculator_credit_rating' in finance_array) {
                    $('#financeCalculatorSmall [name=credit_tier]').val(encodeURIComponent(finance_array['finance_calculator_credit_rating']));
                }

                // update item hidden fields.
                // commenting out for now because the corresponding monthly payment is not updated.
                // changing the hidden fields would mean the hidden fields don't correspond with the displayed price.
                //$('.item [name=credit_tier]').val(encodeURIComponent(finance_array['finance_calculator_credit_rating']));
                //$('.item [name=deposit]').val(encodeURIComponent(finance_array['finance_calculator_deposit']));
                //$('.item [name=term]').val(encodeURIComponent(finance_array['finance_calculator_term']));
                //$('.item [name=annual_mileage]').val(encodeURIComponent(finance_array['finance_calculator_mileage']));

                // update the Build Your Deal CTA.
                // commenting out for now because the corresponding monthly payment is not updated.
                // changing the hidden fields would mean the hidden fields don't correspond with the displayed price.
                //$('.buildYourDealCta [name=credit_tier]').val(encodeURIComponent(finance_array['finance_calculator_credit_rating']));
                //$('.buildYourDealCta [name=deposit]').val(encodeURIComponent(finance_array['finance_calculator_deposit']));
                //$('.buildYourDealCta [name=term]').val(encodeURIComponent(finance_array['finance_calculator_term']));
                //$('.buildYourDealCta [name=annual_mileage]').val(encodeURIComponent(finance_array['finance_calculator_mileage']));

                // variant
                // commenting out for now because the corresponding monthly payment is not updated.
                // changing the hidden fields would mean the hidden fields don't correspond with the displayed price.
                //$('.getStartedMobileWrap [name=credit_tier]').val(encodeURIComponent(finance_array['finance_calculator_credit_rating']));

                $('#loadingOverlay').fadeOut(500);
            }
        });
    }

    // T53875 Set zero as default value when "Nothing to pay" payment plan applies and run the finance calculator
    if ($('#zeroMonthPayment').length) {
        $('input[name=finance_calculator_deposit]').val('0');
        updateFinanceCalculator($('form.financeFormItem'), "first run");
    }

    $(document).on('submit', '#financeCalculator form.financeFormItem, #financeCalculator form.financeFormItemMobile', function (e) {
        e.preventDefault();

        updateFinanceCalculator($(this));

        /**
         * Fetch new savings for savings breakdown block
         * This is currently set to only show/run if CARZ
         * js/site_scripts/mtc_get_savings_breakdown.js
         */
        if ($('.js_itemSavingsBreakdown').length) {
            getUpdatedSavingValues($(this).serialize())
        }

    });

    $(document).on('change', '#financeCalculatorSmall input, #financeCalculatorSmall select', function (e) {
        e.preventDefault();

        $('#financeCalculatorSmall #finance_calculator_submit').trigger('click');
    });

    $(document).on('submit', '#financeCalculatorSmall form.financeFormItemSmall', function (e) {
        e.preventDefault();

        updateFinanceCalculatorSmall($(this));
    });
});
